import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    MenuItem,
    Box,
    Typography,
    Alert,
    CircularProgress
} from '@mui/material';

const EVENT_OPTIONS = [
    { value: 'NEW_BOOKING', label: 'New Booking' },
    { value: 'BOOKING_CANCELLED', label: 'Booking Cancelled' },
    { value: 'PAYMENT_SUCCESS', label: 'Payment Success' },
    { value: 'PAYMENT_FAILED', label: 'Payment Failed' },
    { value: 'CHECK_IN', label: 'Guest Check-In' },
    { value: 'CHECK_OUT', label: 'Guest Check-Out' }
];

const DEFAULT_DATA = {
    guest_name: "John Doe",
    booking_id: "BK-12345",
    amount: "150.00",
    hotel_name: "PMSGO Resort"
};

const SimulateEventModal = ({ open, onClose, onSimulate, loading }) => {
    const [eventName, setEventName] = useState('NEW_BOOKING');
    const [eventData, setEventData] = useState(JSON.stringify(DEFAULT_DATA, null, 4));
    const [error, setError] = useState('');

    const handleSubmit = () => {
        try {
            const parsedData = JSON.parse(eventData);
            setError('');
            onSimulate({ eventName, data: parsedData });
        } catch (e) {
            setError('Invalid JSON format. Please check your data payload.');
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Simulate System Event</DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                        Trigger a mock event to test your notification rules and delivery channels.
                    </Typography>

                    <TextField
                        select
                        label="Event Name"
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                        fullWidth
                    >
                        {EVENT_OPTIONS.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <Box>
                        <Typography variant="subtitle2" gutterBottom>Data Payload (JSON)</Typography>
                        <TextField
                            multiline
                            rows={8}
                            fullWidth
                            value={eventData}
                            onChange={(e) => setEventData(e.target.value)}
                            placeholder='{ "key": "value" }'
                            error={!!error}
                            helperText={error}
                            sx={{ fontFamily: 'monospace' }}
                        />
                    </Box>

                    <Alert severity="info" sx={{ mt: 1 }}>
                        Ensuring your triggers for this event are <b>Active</b> before simulating.
                    </Alert>
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button onClick={onClose} disabled={loading}>Cancel</Button>
                <Button 
                    onClick={handleSubmit} 
                    variant="contained" 
                    disabled={loading}
                    startIcon={loading && <CircularProgress size={20} />}
                >
                    {loading ? 'Simulating...' : 'Simulate Event'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SimulateEventModal;
